// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EhRD","right":"styles_right__3z80Y"};